import { REGISTER_CHANGE } from '../../actions';

const registerReducer = (
  oldState = {
    registerVm: {
      email: '',
      password: '',
      acceptAGBs: new Set()
    }
  },
  action
) => {
  const { registerVm } = oldState;

  switch (action.type) {
    case REGISTER_CHANGE:
    {
      const { name, value } = action;
      if ((registerVm[name]) instanceof Set) {
        if (registerVm[name].has(value)) {
          registerVm[name].delete(value);
        } else {
          registerVm[name].add(value);
        }
        return { ...oldState, requestVm: { ...registerVm, [name]: new Set(registerVm[name]) } };
      }
      return {
        ...oldState,
        registerVm: {
          ...registerVm,
          [name]: value
        }
      };
    }
    default:
      return oldState;
  }
};

export default registerReducer;



// WEBPACK FOOTER //
// ./src/pages/Register/registerReducer.js